import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class SnackBarService {

  constructor(private _snackBar: MatSnackBar) { }


  showErrorMessage(statusCode: number) {
    let errorMessage = '';
    if (statusCode === 401) {
      errorMessage = "Please login";
    } else if (statusCode === 500) {
      errorMessage = "An internal server error occurred";
    } else {
      errorMessage = "An error occurred: please refresh the screen"
    }
    this.openSnackBar(errorMessage, "Dismiss", 5000);
  }

  openSnackBar(message: string, action: string, duration: number) {
    this._snackBar.open(message, action, {
      duration: duration
    });
  }
}
